import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getOnboardingStateApi,
  updateOnboardingStateApi,
  getAddonDetailsApi,
  createNativeSubscriptionApi,
  IUpdateOnboardingStepPayload,
  IGetAddonDetailsPayload,
  ICreateNativeSubscriptionPayload,
} from "../../apis/UserApis/OnboardingApi";
import { showSnackbar } from "../../slices/SnackbarSlice";

export const getOnboardingStateAction = createAsyncThunk(
  "onboarding/getState",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getOnboardingStateApi();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch onboarding state" }
      );
    }
  }
);

export const updateOnboardingStepAction = createAsyncThunk(
  "onboarding/updateStep",
  async (payload: IUpdateOnboardingStepPayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateOnboardingStateApi(payload);
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to update onboarding step";
      dispatch(
        showSnackbar({
          message: errorMessage,
          type: "error",
        })
      );
      return rejectWithValue(
        error?.response?.data || { message: errorMessage }
      );
    }
  }
);

export const getAddonDetailsAction = createAsyncThunk(
  "onboarding/getAddonDetails",
  async (payload: IGetAddonDetailsPayload, { rejectWithValue }) => {
    try {
      const response = await getAddonDetailsApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch addon details" }
      );
    }
  }
);

export const createNativeSubscriptionAction = createAsyncThunk(
  "onboarding/createNativeSubscription",
  async (
    payload: ICreateNativeSubscriptionPayload,
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await createNativeSubscriptionApi(payload);
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to create subscription";
      dispatch(
        showSnackbar({
          message: errorMessage,
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data || { message: errorMessage },
      );
    }
  },
);
